//@ts-nocheck
import TimeConsuming from "./plugin/time_consuming";
function cutOffTitle(title) {
  if (title.length <= 20) {
    return title;
  }
  return "".concat(title.substring(0, 10)).concat(title.substring(title.length - 10), "|").concat(title.length - 20);
}
var DelayReport = function DelayReport(tracert, cb) {
  var Tracert = tracert;
  Tracert.before('logPv', function (obj) {
    var _Tracert$timeConsumin;
    var timeData = Tracert === null || Tracert === void 0 ? void 0 : (_Tracert$timeConsumin = Tracert.timeConsuming) === null || _Tracert$timeConsumin === void 0 ? void 0 : _Tracert$timeConsumin.getTime();
    if (timeData) obj._consume = timeData; // eslint-disable-line no-param-reassign
    obj._title = cutOffTitle(document.title); // eslint-disable-line no-param-reassign
    Tracert.timeConsuming.cache();
    Tracert.timeConsuming.start();
  });
  var timeConsuming = new TimeConsuming(Tracert);
  Tracert.set({
    timeConsuming: timeConsuming
  });
  cb();
  return Tracert;
};
export default DelayReport;